exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/**\r\n * Author: Roberto Metere\r\n */\r\ndiv.navbar {\r\n  border: solid 2px red;\r\n  padding: 5px;\r\n}\r\n\r\n.navbar-brand > img {\r\n  margin-right: 7px;\r\n}\r\n", ""]);
